(() => {
  const ready = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  const formatMoney = (cents, moneyFormat) => {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat || undefined);
      }
    } catch (_) { /* fall through */ }
    const amount = (Number(cents) / 100).toFixed(2);
    if (moneyFormat && moneyFormat.indexOf('{{') !== -1) {
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)))
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    return amount;
  };

  ready(() => {
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('is-open');
        menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    document.querySelectorAll('[data-qty-btn]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.quantity')?.querySelector('[data-qty-input]');
        if (!input) return;
        const step = Number(btn.dataset.qtyBtn);
        const min = Number(input.min || 1);
        const next = Math.max(min, Number(input.value || 1) + step);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    const sticky = document.querySelector('[data-sticky-atc]');
    const form = document.querySelector('[data-product-form]');
    if (sticky && form) {
      const io = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((e) => e.isIntersecting);
          const show = !visible;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('has-sticky-atc', show);
        },
        { threshold: 0.2 }
      );
      io.observe(form);
    }

    const stickyBtn = document.querySelector('[data-sticky-atc-submit]');
    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }

    /* ---------- Canvas gallery + lightbox ---------- */
    const gallery = document.querySelector('[data-product-gallery]');
    const lightbox = document.querySelector('[data-gallery-lightbox]');
    let galleryIndex = 0;
    let galleryItems = [];

    if (gallery) {
      const mainImg = gallery.querySelector('[data-gallery-main-img]');
      const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
      galleryItems = thumbs.map((t) => ({
        id: t.dataset.mediaId,
        src: t.dataset.src,
        srcset: t.dataset.srcset,
        alt: t.dataset.alt || ''
      }));
      if (!galleryItems.length && mainImg) {
        galleryItems = [{
          id: mainImg.dataset.mediaId,
          src: mainImg.currentSrc || mainImg.src,
          srcset: mainImg.srcset,
          alt: mainImg.alt || ''
        }];
      }

      const setMain = (thumbOrItem, index) => {
        if (!mainImg) return;
        let item = thumbOrItem;
        let thumb = null;
        if (thumbOrItem && thumbOrItem.dataset) {
          thumb = thumbOrItem;
          item = {
            id: thumb.dataset.mediaId,
            src: thumb.dataset.src,
            srcset: thumb.dataset.srcset,
            alt: thumb.dataset.alt || ''
          };
          index = thumbs.indexOf(thumb);
        }
        if (!item) return;
        if (typeof index === 'number' && index >= 0) galleryIndex = index;
        mainImg.src = item.src || mainImg.src;
        if (item.srcset) mainImg.srcset = item.srcset;
        if (item.alt) mainImg.alt = item.alt;
        mainImg.dataset.mediaId = item.id || '';
        thumbs.forEach((t, i) => {
          const active = item.id
            ? String(t.dataset.mediaId) === String(item.id)
            : i === galleryIndex;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      };

      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => setMain(thumb, i));
      });

      gallery._setMainFromMediaId = (mediaId) => {
        if (!mediaId) return;
        const match = thumbs.find((t) => String(t.dataset.mediaId) === String(mediaId));
        if (match) setMain(match, thumbs.indexOf(match));
      };

      const fitBtn = gallery.querySelector('[data-gallery-fit]');
      if (fitBtn && mainImg) {
        fitBtn.addEventListener('click', () => {
          const contain = mainImg.classList.toggle('is-contain');
          mainImg.classList.toggle('is-cover', !contain);
          fitBtn.setAttribute('aria-pressed', contain ? 'true' : 'false');
          const label = fitBtn.querySelector('[data-fit-label]');
          if (label) label.textContent = contain ? 'Contain' : 'Cover';
        });
      }

      const openLightbox = (startIndex) => {
        if (!lightbox || galleryItems.length === 0) return;
        galleryIndex = Math.max(0, Math.min(galleryItems.length - 1, startIndex || 0));
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('has-lightbox');
        renderLightbox();
        const closeBtn = lightbox.querySelector('[data-lightbox-close]');
        if (closeBtn && typeof closeBtn.focus === 'function') closeBtn.focus();
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('has-lightbox');
      };

      const renderLightbox = () => {
        if (!lightbox) return;
        const item = galleryItems[galleryIndex];
        if (!item) return;
        const img = lightbox.querySelector('[data-lightbox-img]');
        const counter = lightbox.querySelector('[data-lightbox-counter]');
        if (img) {
          img.src = item.src;
          if (item.srcset) img.srcset = item.srcset;
          img.alt = item.alt || '';
        }
        if (counter) counter.textContent = (galleryIndex + 1) + ' / ' + galleryItems.length;
        setMain(item, galleryIndex);
      };

      const stepLightbox = (delta) => {
        if (!galleryItems.length) return;
        galleryIndex = (galleryIndex + delta + galleryItems.length) % galleryItems.length;
        renderLightbox();
      };

      gallery.querySelectorAll('[data-gallery-open]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          let idx = galleryIndex;
          if (mainImg && mainImg.dataset.mediaId) {
            const found = galleryItems.findIndex((it) => String(it.id) === String(mainImg.dataset.mediaId));
            if (found >= 0) idx = found;
          }
          openLightbox(idx);
        });
      });

      if (lightbox) {
        lightbox.querySelectorAll('[data-lightbox-close]').forEach((el) => {
          el.addEventListener('click', closeLightbox);
        });
        const prev = lightbox.querySelector('[data-lightbox-prev]');
        const next = lightbox.querySelector('[data-lightbox-next]');
        if (prev) prev.addEventListener('click', () => stepLightbox(-1));
        if (next) next.addEventListener('click', () => stepLightbox(1));

        document.addEventListener('keydown', (e) => {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft') stepLightbox(-1);
          if (e.key === 'ArrowRight') stepLightbox(1);
        });

        const stage = lightbox.querySelector('[data-lightbox-stage]');
        if (stage) {
          let touchX = null;
          stage.addEventListener('touchstart', (e) => {
            touchX = e.changedTouches[0].screenX;
          }, { passive: true });
          stage.addEventListener('touchend', (e) => {
            if (touchX == null) return;
            const dx = e.changedTouches[0].screenX - touchX;
            touchX = null;
            if (Math.abs(dx) < 40) return;
            stepLightbox(dx < 0 ? 1 : -1);
          }, { passive: true });
        }
      }
    }

    /* ---------- Variant + pack / bundle ---------- */
    const section = document.querySelector('[data-product-section]');
    const jsonEl = document.querySelector('[data-product-json]');
    if (section && form && jsonEl) {
      let productData = null;
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (_) {
        productData = null;
      }

      if (productData && Array.isArray(productData.variants)) {
        const variantInput = form.querySelector('[data-product-variant-id]');
        const optionSelects = Array.from(form.querySelectorAll('[data-option-select]'));
        const atcBtn = form.querySelector('[data-atc-button]');
        const atcLabel = form.querySelector('[data-atc-label]');
        const atcPrice = form.querySelector('[data-atc-price]');
        const priceWrap = section.querySelector('[data-product-price]');
        const stickyPrice = document.querySelector('[data-sticky-price]');
        const saleBadges = section.querySelectorAll('[data-sale-badge], [data-sale-badge-inline]');
        const qtyInput = form.querySelector('[data-qty-input]');
        const packProp = form.querySelector('[data-pack-property]');
        const packCards = Array.from(section.querySelectorAll('[data-pack-card]'));
        const packUnitEl = section.querySelector('[data-pack-unit-price]');
        const moneyFormat = section.dataset.moneyFormat || (window.Shopify && window.Shopify.money_format) || '';
        const packMode = section.dataset.packMode || 'none';
        const packOptionPosition = Number(section.dataset.packOptionPosition || 0);
        const pack2Discount = Number(section.dataset.pack2Discount || 0);
        const pack3Discount = Number(section.dataset.pack3Discount || 0);

        const addLabel = (atcLabel && atcLabel.textContent.trim()) || 'Add to cart';
        const soldLabel = 'Sold out';
        if (atcBtn) {
          atcBtn.dataset.addLabel = addLabel;
          atcBtn.dataset.soldLabel = soldLabel;
        }

        let activePackQty = 1;
        let syncingPack = false;

        const getSelectedOptions = () =>
          optionSelects.map((sel) => sel.value);

        const findVariant = (overrideOptions) => {
          const selected = overrideOptions || getSelectedOptions();
          if (!selected.length) return productData.variants.find((v) => v.available) || productData.variants[0];
          return productData.variants.find((v) =>
            selected.every((val, i) => String(v['option' + (i + 1)]) === String(val))
          );
        };

        const discountForQty = (qty) => {
          if (qty >= 3) return pack3Discount;
          if (qty === 2) return pack2Discount;
          return 0;
        };

        const estimatePackTotal = (unitCents, qty, discountPct) => {
          const raw = Number(unitCents) * Number(qty);
          if (!discountPct) return raw;
          return Math.round(raw * (1 - Number(discountPct) / 100));
        };

        const setAtcLabel = (available) => {
          const label = available ? (atcBtn?.dataset.addLabel || addLabel) : (atcBtn?.dataset.soldLabel || soldLabel);
          if (atcLabel) atcLabel.textContent = label;
          else if (atcBtn && !atcPrice) atcBtn.textContent = label;
        };

        const updatePriceUI = (variant, displayCents, meta) => {
          if (!priceWrap || !variant) return;
          const cents = typeof displayCents === 'number' ? displayCents : variant.price;
          const current = priceWrap.querySelector('.price__current');
          const compareWrap = priceWrap.querySelector('.price__compare');
          const compareAt = meta && meta.compareAt != null
            ? meta.compareAt
            : (variant.compare_at_price && variant.compare_at_price > variant.price ? variant.compare_at_price : null);
          const onSale = compareAt && compareAt > cents;
          if (current) {
            current.innerHTML = '<span class="visually-hidden">Regular price</span>' + formatMoney(cents, moneyFormat);
          }
          if (compareWrap) {
            if (onSale) {
              compareWrap.hidden = false;
              compareWrap.style.display = '';
              compareWrap.innerHTML = '<span class="visually-hidden">Sale price</span><s>' + formatMoney(compareAt, moneyFormat) + '</s>';
            } else {
              compareWrap.hidden = true;
              compareWrap.style.display = 'none';
            }
          }
          const priceEl = priceWrap.querySelector('.price');
          if (priceEl) priceEl.classList.toggle('price--on-sale', !!onSale);
          saleBadges.forEach((badge) => {
            badge.hidden = !onSale;
            badge.style.display = onSale ? '' : 'none';
          });
          if (stickyPrice) stickyPrice.textContent = formatMoney(cents, moneyFormat);
          if (atcPrice) atcPrice.textContent = formatMoney(cents, moneyFormat);
          if (packUnitEl) {
            if (meta && meta.unitLabel) {
              packUnitEl.hidden = false;
              packUnitEl.textContent = meta.unitLabel;
            } else {
              packUnitEl.hidden = true;
              packUnitEl.textContent = '';
            }
          }
        };

        const refreshPackCardPrices = (baseVariant) => {
          if (!packCards.length || !baseVariant) return;
          packCards.forEach((card) => {
            const qty = Number(card.dataset.packQty || 1);
            const priceEl = card.querySelector('[data-pack-card-price]');
            const metaEl = card.querySelector('[data-pack-card-meta]');
            const badge = card.querySelector('.product-pack__badge');
            if (packMode === 'variant') {
              const value = card.dataset.packValue;
              if (!value) return;
              const opts = getSelectedOptions().slice();
              const pos = packOptionPosition;
              if (pos >= 1 && pos <= opts.length) opts[pos - 1] = value;
              const v = findVariant(opts) || productData.variants.find((vr) => {
                return String(vr['option' + pos]) === String(value);
              });
              if (v && priceEl) {
                priceEl.textContent = formatMoney(v.price, moneyFormat);
                card.dataset.variantId = String(v.id);
                card.dataset.available = v.available ? 'true' : 'false';
                if (metaEl) {
                  const unit = Math.round(v.price / qty);
                  metaEl.textContent = qty > 1
                    ? (formatMoney(unit, moneyFormat) + ' each')
                    : 'Single';
                }
                if (badge && qty > 1 && baseVariant.price) {
                  const singleTotal = baseVariant.price * qty;
                  if (v.price < singleTotal) {
                    const saved = Math.round((1 - v.price / singleTotal) * 100);
                    if (saved > 0) {
                      badge.hidden = false;
                      badge.textContent = 'Save ' + saved + '%';
                    }
                  }
                }
              }
            } else if (packMode === 'quantity') {
              const discount = Number(card.dataset.packDiscount || discountForQty(qty));
              const total = estimatePackTotal(baseVariant.price, qty, discount);
              if (priceEl) priceEl.textContent = formatMoney(total, moneyFormat);
              if (metaEl) {
                if (qty === 1) metaEl.textContent = 'Each';
                else if (discount > 0) metaEl.textContent = 'Est. ' + formatMoney(Math.round(total / qty), moneyFormat) + ' each';
                else metaEl.textContent = 'Qty ' + qty;
              }
            }
          });
        };

        const applyPackSelection = (card, { fromUser } = {}) => {
          if (!card) return;
          const qty = Number(card.dataset.packQty || 1);
          activePackQty = qty;
          packCards.forEach((c) => {
            const on = c === card;
            c.classList.toggle('is-active', on);
            c.setAttribute('aria-pressed', on ? 'true' : 'false');
          });

          if (packMode === 'quantity') {
            if (qtyInput) {
              syncingPack = true;
              qtyInput.value = String(qty);
              syncingPack = false;
            }
            if (packProp) {
              const propName = packProp.dataset.packPropertyName || 'properties[Pack]';
              if (qty > 1) {
                packProp.disabled = false;
                packProp.name = propName;
                packProp.value = card.dataset.packLabel || (qty + ' Pack');
              } else {
                packProp.disabled = true;
                packProp.removeAttribute('name');
                packProp.value = '';
              }
            }
          } else if (packMode === 'variant') {
            const packSelect = form.querySelector('[data-pack-option-select]');
            const value = card.dataset.packValue;
            if (packSelect && value && packSelect.value !== value) {
              syncingPack = true;
              packSelect.value = value;
              syncingPack = false;
            }
            if (qtyInput && fromUser) {
              syncingPack = true;
              qtyInput.value = '1';
              syncingPack = false;
            }
            if (packProp) {
              packProp.disabled = true;
              packProp.removeAttribute('name');
              packProp.value = '';
            }
          }
          applyVariant();
        };

        const applyVariant = () => {
          const variant = findVariant();
          if (!variant || !variantInput) return;
          variantInput.value = variant.id;

          let displayCents = variant.price;
          let meta = {};
          const qty = qtyInput ? Math.max(1, Number(qtyInput.value || 1)) : 1;

          if (packMode === 'quantity' && qty > 1) {
            const discount = discountForQty(qty);
            displayCents = estimatePackTotal(variant.price, qty, discount);
            meta.compareAt = variant.compare_at_price && variant.compare_at_price > variant.price
              ? variant.compare_at_price * qty
              : variant.price * qty;
            meta.unitLabel = discount > 0
              ? ('Est. ' + formatMoney(Math.round(displayCents / qty), moneyFormat) + ' / unit · display only')
              : '';
          } else if (packMode === 'variant') {
            const active = packCards.find((c) => c.classList.contains('is-active'));
            const q = active ? Number(active.dataset.packQty || 1) : 1;
            if (q > 1) {
              meta.unitLabel = formatMoney(Math.round(variant.price / q), moneyFormat) + ' / unit';
            }
          }

          updatePriceUI(variant, displayCents, meta);
          let baseline = variant;
          if (packMode === 'variant') {
            const singleCard = packCards.find((c) => Number(c.dataset.packQty) === 1);
            if (singleCard && singleCard.dataset.packValue && packOptionPosition >= 1) {
              const opts = getSelectedOptions().slice();
              opts[packOptionPosition - 1] = singleCard.dataset.packValue;
              baseline = findVariant(opts) || variant;
            }
          }
          refreshPackCardPrices(baseline);

          const available = !!variant.available;
          if (atcBtn) {
            atcBtn.disabled = !available;
            setAtcLabel(available);
          }
          if (stickyBtn) stickyBtn.disabled = !available;

          const mediaId = (variant.featured_media && variant.featured_media.id)
            || (variant.featured_image && (variant.featured_image.id || variant.featured_image));
          if (mediaId && gallery && gallery._setMainFromMediaId) {
            gallery._setMainFromMediaId(mediaId);
          }
        };

        optionSelects.forEach((sel) => {
          sel.addEventListener('change', () => {
            if (syncingPack) {
              applyVariant();
              return;
            }
            if (packMode === 'variant' && sel.hasAttribute('data-pack-option-select')) {
              const match = packCards.find((c) => c.dataset.packValue === sel.value);
              if (match) applyPackSelection(match);
              else applyVariant();
              return;
            }
            applyVariant();
          });
        });

        if (qtyInput) {
          qtyInput.addEventListener('change', () => {
            if (syncingPack) return;
            if (packMode === 'quantity' && packCards.length) {
              const q = Math.max(1, Number(qtyInput.value || 1));
              const match = packCards.find((c) => Number(c.dataset.packQty) === q)
                || packCards.find((c) => Number(c.dataset.packQty) === 1);
              if (match) {
                applyPackSelection(match);
                if (q !== Number(match.dataset.packQty) && qtyInput) {
                  // Custom qty outside 1/2/3 — keep qty, clear pack property if not 2/3
                  syncingPack = true;
                  qtyInput.value = String(q);
                  syncingPack = false;
                  if (packProp) {
                    const propName = packProp.dataset.packPropertyName || 'properties[Pack]';
                    if (q === 2 || q === 3) {
                      packProp.disabled = false;
                      packProp.name = propName;
                      packProp.value = q + ' Pack';
                    } else {
                      packProp.disabled = true;
                      packProp.removeAttribute('name');
                      packProp.value = '';
                    }
                  }
                  applyVariant();
                }
                return;
              }
            }
            applyVariant();
          });
        }

        packCards.forEach((card) => {
          card.addEventListener('click', () => applyPackSelection(card, { fromUser: true }));
        });

        // Initial sync
        if (packCards.length) {
          let initial = packCards.find((c) => c.classList.contains('is-active')) || packCards[0];
          if (packMode === 'variant') {
            const packSelect = form.querySelector('[data-pack-option-select]');
            if (packSelect) {
              const byValue = packCards.find((c) => c.dataset.packValue === packSelect.value);
              if (byValue) initial = byValue;
            }
          }
          applyPackSelection(initial);
        } else {
          applyVariant();
        }
      }
    }
  });
})();
